/**
 * Delays resolving for a specific period of time
 * @param {number} time
 */
const Delay = function (time: number)
{
    return new Promise((resolve) =>
    {
        setTimeout(resolve, time);
    })
}

export default Delay;